import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { compose } from 'recompose'
import { updateTenantApplication } from 'api'
import {
  withJsonApiProps,
  withLayout,
  useStepFormSubmit,
  useOrderedSteps,
  goToNextStep,
} from 'utils'
import { ApplicationLayout } from 'components'
import { HudBrochureAckForm } from 'forms'
import { STEP } from 'config'

// All files served from S3 via /brochures/:filename
const BROCHURES = [
  {
    name: 'HUD-1141 – Is Fraud Worth It? Brochure',
    url: '/brochures/1141.pdf',
  },
  {
    name: '"How Your Rent is Determined" Fact Sheet',
    url: '/brochures/HUD-Fact-Sheet-How-Your-Rent-is-Determined-2024.pdf',
  },
  {
    name: "Resident's Rights and Responsibilities Brochure",
    url: '/brochures/resident_rights_brochure_8.pdf',
  },
  {
    name: 'EIV & You Brochure',
    url: '/brochures/EIV-And-You-Brochure-t5lu3u.pdf',
  },
  {
    name: 'Lead-Based Paint Disclosure Brochure',
    url: '/brochures/protectyourfamily_pamphlet_2026_3.pdf',
  },
  {
    name: 'VAWA – Notice of Occupancy Rights',
    url: '/brochures/Chart-VAWA-Covered-Housing.pdf',
  },
]

const propTypes = {
  brochuresReceived: PropTypes.string,
}
const defaultProps = {}

function HudBrochureAck({ brochuresReceived }) {
  const { handleSubmitUpdate } = useStepFormSubmit({
    updateRequest: updateTenantApplication,
  })
  const [steps] = useOrderedSteps()

  return (
    <>
      <Helmet>
        <title>HUD Required Documents</title>
      </Helmet>
      <div className="page-header">
        <h1>Acknowledgement of Receipt of HUD Required Documents</h1>
        <p>
          This form must be completed by the Head of Household only (unless noted below).
          All household members should review these documents.
        </p>
        <p>
          Please review each of the following required HUD documents by clicking the link
          to open and read it. Then check the acknowledgment box below to confirm receipt.
        </p>
      </div>

      <div className="card p-4 mb-4">
        <p className="mb-3">
          <strong>
            I verify that I have received a copy of the following documents and was given
            the opportunity to ask questions:
          </strong>
        </p>
        <ul className="list-group list-group-flush">
          {BROCHURES.map((brochure) => (
            <li key={brochure.name} className="list-group-item px-0 py-3">
              <a
                href={brochure.url}
                target="_blank"
                rel="noopener noreferrer"
                className="fw-semibold text-decoration-none"
                style={{ color: '#0066cc', fontSize: '1.05rem' }}
              >
                {brochure.name} ↗
              </a>
            </li>
          ))}
        </ul>
      </div>

      <HudBrochureAckForm
        initialValues={{
          tenantApplication: {
            brochuresReceived: brochuresReceived || '',
          },
        }}
        onSubmit={async () => {
          const isSubmitSuccess = await handleSubmitUpdate({
            tenantApplication: {
              brochuresReceived: new Date().toISOString(),
              currentStep: STEP.HUD_BROCHURE_ACK.name,
            },
          })
          if (isSubmitSuccess) {
            const ackIndex = steps.findIndex(
              (s) => s?.name === STEP.HUD_BROCHURE_ACK.name
            )
            const nextStep = steps[ackIndex + 1]
            if (nextStep) goToNextStep(nextStep)
          }
        }}
      />
    </>
  )
}

HudBrochureAck.propTypes = propTypes
HudBrochureAck.defaultProps = defaultProps

export default compose(
  withJsonApiProps(),
  withLayout(ApplicationLayout)
)(HudBrochureAck)
